import { Card, CardContent } from '@/components/ui/card'
import {
  formatDistanceMeters,
  formatDurationMinutes,
  formatTimeJST,
  getMotionConfig,
} from '@/lib/activity-format-utils'
import type { MovementSessionWithVisits } from '@/lib/movement-session'

type OverlandMovementCardProps = {
  session: MovementSessionWithVisits
  onClick?: (session: MovementSessionWithVisits) => void
}

export function OverlandMovementCard({ session, onClick }: OverlandMovementCardProps) {
  const { icon: Icon, color, bgColor, label } = getMotionConfig(session.motion)

  const startTime = new Date(session.startTime)
  const endTime = new Date(session.endTime)
  const durationMinutes = (endTime.getTime() - startTime.getTime()) / (1000 * 60)
  const distanceMeters = session.estimatedDistanceKm * 1000

  return (
    <Card className="hover:shadow-md transition-shadow p-0 cursor-pointer" onClick={() => onClick?.(session)}>
      <CardContent className="p-3">
        <span className="flex justify-end text-xs text-muted-foreground">
          {formatTimeJST(session.startTime)} → {formatTimeJST(session.endTime)}
        </span>
        <div className="flex items-start gap-3">
          <div className={`p-2 rounded-lg ${bgColor}`}>
            <Icon className={`h-5 w-5 ${color}`} />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-medium truncate">{label}</h3>

            <div className="flex items-center gap-3 mt-2 text-sm text-muted-foreground">
              <span>{formatDistanceMeters(distanceMeters)}</span>
              <span>•</span>
              <span>{formatDurationMinutes(durationMinutes)}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
